var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToHostCohort2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 960.4 220.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-10);}.cls-5{fill:#fff;}.cls-6{fill:url(#linear-gradient-12);}.cls-7{fill:url(#linear-gradient-13);}.cls-8{fill:url(#linear-gradient-15);}.cls-9{fill:url(#linear-gradient-16);}.cls-10{fill:url(#linear-gradient-18);}.cls-11{fill:url(#linear-gradient-19);}.cls-12{fill:url(#linear-gradient-21);}.cls-13{fill:url(#linear-gradient-23);}.cls-14{fill:url(#linear-gradient-24);}.cls-15{fill:url(#linear-gradient-26);}.cls-16{fill:url(#linear-gradient-27);}.cls-17{fill:url(#linear-gradient-28);}.cls-18{fill:url(#linear-gradient-29);}.cls-19{fill:url(#linear-gradient-34);}.cls-20{fill:url(#linear-gradient-35);}.cls-21{fill:url(#linear-gradient-36);}.cls-22{fill:url(#linear-gradient-37);}.cls-23{fill:url(#linear-gradient-38);}.cls-24{fill:url(#linear-gradient-39);}.cls-25{fill:url(#linear-gradient-40);}.cls-26{fill:url(#linear-gradient-41);}.cls-27{fill:url(#linear-gradient-42);}.cls-28{fill:url(#linear-gradient-43);}.cls-29{fill:url(#linear-gradient-44);}.cls-30{fill:url(#linear-gradient-45);}.cls-31{fill:url(#linear-gradient-46);}.cls-32{fill:url(#linear-gradient-47);}.cls-33{fill:url(#linear-gradient-48);}.cls-34{fill:url(#linear-gradient-49);}.cls-35{fill:url(#linear-gradient-51);}.cls-36{fill:url(#linear-gradient-52);}.cls-37{fill:url(#linear-gradient-53);}.cls-38{fill:url(#linear-gradient-54);}.cls-39{fill:url(#linear-gradient-55);}.cls-40{fill:url(#linear-gradient-56);}.cls-41{fill:url(#linear-gradient-57);}.cls-42{fill:url(#linear-gradient-58);}.cls-43{fill:url(#linear-gradient-60);}.cls-44{fill:url(#linear-gradient-62);}.cls-45{fill:url(#linear-gradient-63);}.cls-46{fill:url(#linear-gradient-64);}.cls-47{fill:url(#linear-gradient-65);}.cls-48{fill:url(#linear-gradient-66);}.cls-49{fill:url(#linear-gradient-67);}.cls-50{fill:url(#linear-gradient-68);}.cls-51{fill:url(#linear-gradient-69);}.cls-52{fill:url(#linear-gradient-70);}.cls-53{fill:url(#linear-gradient-74);}.cls-54{fill:url(#linear-gradient-75);}.cls-55{fill:url(#linear-gradient-76);}.cls-56{fill:url(#linear-gradient-78);}.cls-57{fill:url(#linear-gradient-79);}.cls-58{fill:url(#linear-gradient-80);}.cls-59{fill:url(#linear-gradient-81);}.cls-60{fill:url(#linear-gradient-82);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 63.04,
    y1: 110.36,
    x2: 895.64,
    y2: 110.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 63.48,
    y1: 213.65,
    x2: 1311.74,
    y2: 213.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 63.48,
    y1: 7.13,
    x2: 1311.74,
    y2: 7.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 63.47,
    y1: 213.65,
    x2: 1311.73,
    y2: 213.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 480.2,
    y1: 39.42,
    x2: 480.2,
    y2: 167.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 480.2,
    y1: 50.41,
    x2: 480.2,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 480.2,
    y1: 50.41,
    x2: 480.2,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 480.3,
    y1: 50.41,
    x2: 480.3,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 456.49,
    y1: 50.41,
    x2: 456.49,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 503.92,
    y1: 50.41,
    x2: 503.92,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 480.29,
    y1: 50.41,
    x2: 480.29,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 458.82,
    y1: 50.41,
    x2: 458.82,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 501.59,
    y1: 50.41,
    x2: 501.59,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 270.67,
    y1: 39.42,
    x2: 270.67,
    y2: 167.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 270.67,
    y1: 50.41,
    x2: 270.67,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 270.67,
    y1: 50.41,
    x2: 270.67,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 270.67,
    y1: 50.41,
    x2: 270.67,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 687.74,
    y1: 39.42,
    x2: 687.74,
    y2: 167.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 687.85,
    y1: 50.41,
    x2: 687.85,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 676.16,
    y1: 50.41,
    x2: 676.16,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 699.54,
    y1: 50.41,
    x2: 699.54,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 687.87,
    y1: 50.41,
    x2: 687.87,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 657.06,
    y1: 50.41,
    x2: 657.06,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 645.36,
    y1: 50.41,
    x2: 645.36,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 668.75,
    y1: 50.41,
    x2: 668.75,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 657.08,
    y1: 50.41,
    x2: 657.08,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 718.42,
    y1: 50.41,
    x2: 718.42,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 706.72,
    y1: 50.41,
    x2: 706.72,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 730.11,
    y1: 50.41,
    x2: 730.11,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 718.44,
    y1: 50.41,
    x2: 718.44,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 660.16,
    y1: 50.41,
    x2: 660.16,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 715.62,
    y1: 50.41,
    x2: 715.62,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 687.87,
    y1: 50.41,
    x2: 687.87,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 896.27,
    y1: 39.42,
    x2: 896.27,
    y2: 167.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 892.77,
    y1: 50.41,
    x2: 892.77,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 894.51,
    y1: 50.41,
    x2: 894.51,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 891.23,
    y1: 50.41,
    x2: 891.23,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 891.23,
    y1: 50.41,
    x2: 891.23,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 897.99,
    y1: 50.41,
    x2: 897.99,
    y2: 172.69,
    gradientTransform: "translate(388.1 -633.93) rotate(48.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 870.89,
    y1: 50.41,
    x2: 870.89,
    y2: 172.69,
    gradientTransform: "translate(324.59 -587.02) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 891.23,
    y1: 50.41,
    x2: 891.23,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 863.33,
    y1: 50.41,
    x2: 863.33,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 858.2,
    y1: 50.41,
    x2: 858.2,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 923.2,
    y1: 50.41,
    x2: 923.2,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 921.55,
    y1: 50.41,
    x2: 921.55,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 64.13,
    y1: 39.42,
    x2: 64.13,
    y2: 167.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 66.79,
    y1: 50.41,
    x2: 66.79,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 66.79,
    y1: 50.41,
    x2: 66.79,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 87.73,
    y1: 50.41,
    x2: 87.73,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 66.79,
    y1: 50.41,
    x2: 66.79,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 52.4,
    y1: 50.41,
    x2: 52.4,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 74.29,
    y1: 50.41,
    x2: 74.29,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 69.67,
    y1: 50.41,
    x2: 69.67,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 67.14,
    y1: 50.41,
    x2: 67.14,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 93.5,
    y1: 50.41,
    x2: 93.5,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 93.5,
    y1: 50.41,
    x2: 93.5,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 28.89,
    y1: 50.41,
    x2: 28.89,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 22.4,
    y1: 50.41,
    x2: 22.4,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 28.89,
    y1: 50.41,
    x2: 28.89,
    y2: 172.69,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGN_ICON_Resize_mayuri",
    "data-name": "DESIGN ICON Resize mayuri"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "897.37 7.66 897.37 212.98 687.5 212.98 687.5 7.66 483.12 7.66 483.12 214.31 271 214.31 271 8.32 64.61 8.32 64.61 213.35 63.04 212.1 63.04 7.07 272.57 7.07 272.57 213.06 481.55 213.06 481.55 6.41 689.08 6.41 689.08 211.73 895.79 211.73 895.79 6.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.19,209C54,215.29,59.27,222,65.46,220.6a7.07,7.07,0,0,0,5.31-5.32c1.37-6.18-5.3-11.42-11.58-7.26A3.66,3.66,0,0,0,58.19,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.19,2.49c-4.16,6.28,1.08,13,7.27,11.58a7.06,7.06,0,0,0,5.31-5.31c1.37-6.19-5.3-11.43-11.58-7.27A3.66,3.66,0,0,0,58.19,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.15,2.49c-4.16,6.28,1.08,13,7.27,11.58a7.06,7.06,0,0,0,5.31-5.31c1.37-6.19-5.3-11.43-11.58-7.27A3.66,3.66,0,0,0,266.15,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.15,209c-4.16,6.27,1.08,12.95,7.27,11.58a7.07,7.07,0,0,0,5.31-5.32c1.37-6.18-5.3-11.42-11.58-7.26A3.66,3.66,0,0,0,266.15,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.61,209c-4.16,6.27,1.08,12.95,7.27,11.58a7.07,7.07,0,0,0,5.31-5.32c1.37-6.18-5.3-11.42-11.58-7.26A3.66,3.66,0,0,0,476.61,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M476.63,2.49c-4.16,6.28,1.08,13,7.26,11.58a7.07,7.07,0,0,0,5.32-5.31c1.37-6.19-5.3-11.43-11.58-7.27A3.66,3.66,0,0,0,476.63,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M681,2.49c-4.16,6.28,1.08,13,7.27,11.58a7.06,7.06,0,0,0,5.31-5.31C695,2.57,688.3-2.67,682,1.49A3.66,3.66,0,0,0,681,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.23,209c-4.16,6.27,1.08,12.95,7.27,11.58a7.07,7.07,0,0,0,5.31-5.32c1.37-6.18-5.3-11.42-11.57-7.26A3.56,3.56,0,0,0,684.23,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M891.48,209c-4.16,6.27,1.08,12.95,7.27,11.58a7.07,7.07,0,0,0,5.31-5.32c1.37-6.18-5.3-11.42-11.58-7.26A3.66,3.66,0,0,0,891.48,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M891.27,2.49c-4.16,6.28,1.08,13,7.27,11.58a7.06,7.06,0,0,0,5.31-5.31c1.37-6.19-5.3-11.43-11.57-7.27A3.56,3.56,0,0,0,891.27,2.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 48.26,
    width: 128.26,
    height: 128.26,
    rx: 10.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 416.07,
    y: 48.26,
    width: 128.26,
    height: 128.26,
    rx: 10.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M533.5,176.52H426.9a10.84,10.84,0,0,1-10.83-10.83V59.09A10.84,10.84,0,0,1,426.9,48.26H533.5a10.84,10.84,0,0,1,10.83,10.83v106.6A10.84,10.84,0,0,1,533.5,176.52ZM426.9,51.68a7.43,7.43,0,0,0-7.41,7.41v106.6a7.43,7.43,0,0,0,7.41,7.41H533.5a7.42,7.42,0,0,0,7.41-7.41V59.09a7.42,7.42,0,0,0-7.41-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M512.75,118.92l-2.48-1.13.57-1.24a33.66,33.66,0,1,0-61.56-.64l.54,1.25-2.5,1.08-.54-1.25a36.39,36.39,0,1,1,66.54.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M498.44,106.24l-2.73-.09,0-1.36c0-.72,0-1.46,0-2.2,0-18.24-7.14-33.66-15.59-33.66s-15.58,15.42-15.58,33.66q0,1.09,0,2.19l0,1.36-2.72.09-.05-1.36c0-.76,0-1.51,0-2.28,0-20.41,8-36.39,18.31-36.39s18.32,16,18.32,36.39c0,.77,0,1.53,0,2.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.84,
    y: 66.2,
    width: 2.73,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 445.09,
    y: 95.07,
    width: 70.43,
    height: 2.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 452.98,
    y: 80.14,
    width: 54.44,
    height: 2.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M456.25,155.76h-2.73V145.07h-4.3V130.8A6.83,6.83,0,0,1,456,124h7.73v2.73H456a4.09,4.09,0,0,0-4.09,4.09v11.54h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M506.88,155.76h-2.73V142.34h4.31V130.8a4.09,4.09,0,0,0-4.09-4.09h-7.72V124h7.72a6.83,6.83,0,0,1,6.82,6.82v14.27h-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.19,158.58h-2.73V143.3h5.42V129.55a5.23,5.23,0,0,0-5.23-5.23h-14.9a5.24,5.24,0,0,0-5.23,5.23V143.3h5.27v15.28h-2.73V146h-5.27V129.55a8,8,0,0,1,8-8h14.9a8,8,0,0,1,8,8V146h-5.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 478.92,
    y: 147.06,
    width: 2.73,
    height: 11.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.84,
    y: 130.89,
    width: 2.73,
    height: 5.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M458.82,121.85a4.74,4.74,0,1,1,4.74-4.74A4.75,4.75,0,0,1,458.82,121.85Zm0-6.75a2,2,0,1,0,2,2A2,2,0,0,0,458.82,115.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M501.59,121.85a4.74,4.74,0,1,1,4.74-4.74A4.75,4.75,0,0,1,501.59,121.85Zm0-6.75a2,2,0,1,0,2,2A2,2,0,0,0,501.59,115.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M480.29,118.76a5.87,5.87,0,1,1,5.87-5.87A5.87,5.87,0,0,1,480.29,118.76Zm0-9a3.14,3.14,0,1,0,3.14,3.14A3.15,3.15,0,0,0,480.29,109.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.54,
    y: 48.26,
    width: 128.26,
    height: 128.26,
    rx: 10.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M324,176.52H217.37a10.84,10.84,0,0,1-10.83-10.83V59.09a10.84,10.84,0,0,1,10.83-10.83H324a10.84,10.84,0,0,1,10.83,10.83v106.6A10.84,10.84,0,0,1,324,176.52ZM217.37,51.68A7.42,7.42,0,0,0,210,59.09v106.6a7.42,7.42,0,0,0,7.41,7.41H324a7.42,7.42,0,0,0,7.41-7.41V59.09A7.42,7.42,0,0,0,324,51.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M315.16,138.46h-89a4.39,4.39,0,0,1-4.48-4.28V76.54a4.39,4.39,0,0,1,4.48-4.28h89a4.39,4.39,0,0,1,4.48,4.28v57.64A4.39,4.39,0,0,1,315.16,138.46Zm-89-63.33a1.52,1.52,0,0,0-1.61,1.41v57.64a1.52,1.52,0,0,0,1.61,1.41h89a1.52,1.52,0,0,0,1.61-1.41V76.54a1.52,1.52,0,0,0-1.61-1.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "285.21 151.43 281.92 138.52 259.41 138.52 256.12 151.43 253.35 150.73 257.19 135.65 284.15 135.65 287.99 150.73 285.21 151.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 240.57,
    y: 149.65,
    width: 60.2,
    height: 2.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 223.13,
    y: 124.73,
    width: 95.08,
    height: 2.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.1,126.17h-2.86v-4.52l-7.19-1.17-.2-1a20.55,20.55,0,0,0-3-7.13l-.54-.82,4.27-5.92-2.89-2.89L282.79,107l-.82-.54a20.48,20.48,0,0,0-7.12-3l-1-.2-1.17-7.19h-4.09l-1.17,7.19-1,.2a20.48,20.48,0,0,0-7.12,3l-.82.54-5.93-4.26-2.89,2.89,4.27,5.92-.54.82a20.55,20.55,0,0,0-3,7.13l-.2,1-7.19,1.17v4.5h-2.86v-4.92a2.38,2.38,0,0,1,2-2.35l5.68-.92a23.35,23.35,0,0,1,2.62-6.31L247.14,107a2.34,2.34,0,0,1,.25-3l3.51-3.51a2.34,2.34,0,0,1,3-.25l4.7,3.39a23.31,23.31,0,0,1,6.3-2.63l.93-5.69a2.35,2.35,0,0,1,2.33-2h4.95a2.35,2.35,0,0,1,2.33,2l.93,5.7a23.31,23.31,0,0,1,6.3,2.63l4.68-3.37a2.38,2.38,0,0,1,3.07.24l3.48,3.49a2.36,2.36,0,0,1,.25,3.06l-3.37,4.68a23,23,0,0,1,2.62,6.31l5.7.93a2.34,2.34,0,0,1,2,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M283.78,124.35h-2.86a10.26,10.26,0,1,0-20.51,0h-2.86a13.12,13.12,0,1,1,26.23,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 238.76,
    y: 83.12,
    width: 63.81,
    height: 2.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 623.61,
    y: 48.26,
    width: 128.26,
    height: 128.26,
    rx: 10.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M741,176.52H634.44a10.84,10.84,0,0,1-10.83-10.83V59.09a10.84,10.84,0,0,1,10.83-10.83H741a10.84,10.84,0,0,1,10.83,10.83v106.6A10.84,10.84,0,0,1,741,176.52ZM634.44,51.68A7.43,7.43,0,0,0,627,59.09v106.6a7.43,7.43,0,0,0,7.41,7.41H741a7.43,7.43,0,0,0,7.41-7.41V59.09A7.43,7.43,0,0,0,741,51.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M687.84,93.06c-4.87,0-8.46-4.48-9.13-11.41-.43-4.37.32-7.64,2.23-9.74,1.58-1.74,3.9-2.63,6.9-2.63s5.4.9,7,2.68c1.89,2.11,2.61,5.38,2.13,9.7h0C696.2,88.59,692.62,93.06,687.84,93.06Zm0-21c-2.23,0-3.82.56-4.88,1.73-1.36,1.5-1.88,4.07-1.53,7.63.53,5.44,3,9,6.41,9s5.81-3.52,6.41-9h0c.39-3.52-.1-6.07-1.46-7.58C691.74,72.61,690.08,72,687.84,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M673.33,106.35H670.6l0-6.75a5.7,5.7,0,0,1,3.7-3.94c2.38-.87,6.36-2.49,6.36-2.49l1,2.53s-4,1.65-6.46,2.53a3,3,0,0,0-1.92,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M705.1,106.35h-2.73v-6.3a3.06,3.06,0,0,0-1.92-1.82C698,97.35,694,95.7,694,95.7l1-2.53s4,1.62,6.36,2.49a5.71,5.71,0,0,1,3.7,3.93l0,.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 686.51,
    y: 99.82,
    width: 2.73,
    height: 5.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M657.05,137.22c-4.87,0-8.46-4.48-9.13-11.42-.43-4.36.32-7.63,2.23-9.73,1.58-1.74,3.9-2.63,6.9-2.63s5.4.9,7,2.68c1.89,2.11,2.61,5.38,2.13,9.7h0C665.41,132.75,661.83,137.22,657.05,137.22Zm0-21c-2.23,0-3.82.57-4.88,1.74-1.36,1.5-1.88,4.07-1.53,7.63.53,5.44,3,9,6.41,9s5.81-3.52,6.41-9h0c.38-3.52-.11-6.07-1.46-7.58A6.35,6.35,0,0,0,657.05,116.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M642.54,150.51h-2.73l0-6.76a5.71,5.71,0,0,1,3.7-3.94c2.38-.86,6.36-2.48,6.36-2.48l1,2.53s-4,1.65-6.46,2.53a3,3,0,0,0-1.92,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M674.31,150.51h-2.73v-6.3a3.06,3.06,0,0,0-1.92-1.82c-2.43-.88-6.46-2.53-6.46-2.53l1-2.53s4,1.62,6.36,2.48a5.69,5.69,0,0,1,3.69,3.94l0,.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 655.71,
    y: 143.97,
    width: 2.73,
    height: 5.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M718.4,137.22c-4.86,0-8.45-4.48-9.12-11.42-.43-4.36.32-7.63,2.22-9.73a8.92,8.92,0,0,1,6.9-2.63c3.05,0,5.4.9,7,2.68,1.89,2.11,2.61,5.38,2.13,9.7h0C726.77,132.75,723.18,137.22,718.4,137.22Zm0-21c-2.22,0-3.81.57-4.87,1.74-1.36,1.5-1.88,4.07-1.53,7.63.53,5.44,3,9,6.4,9s5.81-3.52,6.42-9h0c.38-3.52-.11-6.07-1.46-7.58A6.38,6.38,0,0,0,718.4,116.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M703.9,150.51h-2.73l0-6.76a5.71,5.71,0,0,1,3.7-3.94c2.38-.86,6.35-2.48,6.36-2.48l1,2.53s-4,1.65-6.46,2.53a3,3,0,0,0-1.92,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M735.67,150.51h-2.73v-6.3a3.06,3.06,0,0,0-1.92-1.82c-2.43-.88-6.46-2.53-6.46-2.53l1-2.53s4,1.62,6.36,2.48a5.72,5.72,0,0,1,3.69,3.94l0,.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 717.07,
    y: 143.97,
    width: 2.73,
    height: 5.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M654,110.52h-2.73V99.91a4,4,0,0,1,4-4h13.9v2.73h-13.9A1.22,1.22,0,0,0,654,99.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M724.54,110.52h-2.73V99.91a1.22,1.22,0,0,0-1.22-1.22h-13.9V96h13.9a4,4,0,0,1,3.95,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M690,143.58h-4.16a1.38,1.38,0,0,1-1.3-.93l-1.17-3.52-.27-.11-3.32,1.65a1.37,1.37,0,0,1-1.58-.25l-2.94-2.95a1.35,1.35,0,0,1-.26-1.57l1.66-3.32-.12-.27L673,131.13a1.38,1.38,0,0,1-.94-1.3v-4.16a1.35,1.35,0,0,1,.94-1.29l3.52-1.18.11-.27L675,119.61a1.37,1.37,0,0,1,.26-1.58l2.94-2.94a1.39,1.39,0,0,1,1.58-.26l3.32,1.66.27-.11,1.17-3.52a1.37,1.37,0,0,1,1.3-.93H690a1.37,1.37,0,0,1,1.3.93l1.18,3.52.26.11,3.33-1.66a1.35,1.35,0,0,1,1.57.26l2.94,2.94a1.37,1.37,0,0,1,.26,1.58l-1.65,3.32.11.27,3.51,1.18a1.35,1.35,0,0,1,.94,1.29v4.16a1.38,1.38,0,0,1-.94,1.3l-3.51,1.18-.11.27,1.65,3.32a1.35,1.35,0,0,1-.26,1.57l-2.94,2.95a1.35,1.35,0,0,1-1.57.25L692.69,139l-.26.11-1.18,3.52A1.38,1.38,0,0,1,690,143.58Zm-3.18-2.73H689l1.06-3.18a1.4,1.4,0,0,1,.77-.83l1.42-.59a1.41,1.41,0,0,1,1.14,0l3,1.5,1.56-1.56-1.5-3a1.39,1.39,0,0,1,0-1.13l.59-1.42a1.36,1.36,0,0,1,.83-.78l3.17-1.06v-2.19l-3.17-1.07a1.35,1.35,0,0,1-.83-.77l-.59-1.42a1.39,1.39,0,0,1,0-1.13l1.5-3-1.56-1.55-3,1.49a1.38,1.38,0,0,1-1.14,0l-1.41-.59a1.37,1.37,0,0,1-.78-.82L689,114.66h-2.2l-1.06,3.18a1.38,1.38,0,0,1-.77.82l-1.42.59a1.35,1.35,0,0,1-1.13,0l-3-1.49-1.55,1.55,1.49,3a1.35,1.35,0,0,1,0,1.13l-.59,1.42a1.35,1.35,0,0,1-.83.77l-3.17,1.07v2.19l3.17,1.06a1.36,1.36,0,0,1,.83.78l.59,1.42a1.35,1.35,0,0,1,0,1.13l-1.49,3,1.55,1.56,3-1.5a1.35,1.35,0,0,1,1.13,0l1.42.59a1.4,1.4,0,0,1,.77.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M687.87,134a6.24,6.24,0,1,1,6.24-6.24A6.25,6.25,0,0,1,687.87,134Zm0-9.75a3.51,3.51,0,1,0,3.51,3.51A3.52,3.52,0,0,0,687.87,124.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 832.15,
    y: 48.26,
    width: 128.26,
    height: 128.26,
    rx: 10.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M949.57,176.52H843a10.84,10.84,0,0,1-10.83-10.83V59.09A10.84,10.84,0,0,1,843,48.26H949.57A10.84,10.84,0,0,1,960.4,59.09v106.6A10.84,10.84,0,0,1,949.57,176.52ZM843,51.68a7.42,7.42,0,0,0-7.41,7.41v106.6A7.42,7.42,0,0,0,843,173.1H949.57a7.42,7.42,0,0,0,7.41-7.41V59.09a7.42,7.42,0,0,0-7.41-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M891.23,151.18a29.51,29.51,0,0,1-26.59-16.48l2.23-1.11a27.19,27.19,0,1,0,0-24.23l-2.23-1.12a29.69,29.69,0,1,1,26.57,42.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M891.23,143.91a22.26,22.26,0,0,1-15.76-6.48l1.75-1.77a19.92,19.92,0,1,0-.07-28.25l-1.77-1.76a22.41,22.41,0,1,1,15.85,38.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M891.23,136.63a15.14,15.14,0,0,1,0-30.27v2.5a12.64,12.64,0,1,0,12.64,12.64h2.49A15.15,15.15,0,0,1,891.23,136.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M891.23,126.38a4.88,4.88,0,1,1,4.88-4.88A4.89,4.89,0,0,1,891.23,126.38Zm0-7.27a2.39,2.39,0,1,0,2.38,2.39A2.39,2.39,0,0,0,891.23,119.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 891.52,
    y: 112.75,
    width: 12.95,
    height: 2.49,
    transform: "translate(217.39 710.79) rotate(-48.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 869.65,
    y: 95.91,
    width: 2.49,
    height: 4.77,
    transform: "translate(185.57 644.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 889.98,
    y: 85.35,
    width: 2.49,
    height: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 886.85,
    y: 84.1,
    width: 8.76,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 854.03,
    y: 113.67,
    width: 18.6,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 854.03,
    y: 126.83,
    width: 18.6,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 848.89,
    y: 120.25,
    width: 18.6,
    height: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M931.66,117.85l-4.39-4a17.77,17.77,0,0,1-1.72.64l-.76-2.37a14.88,14.88,0,0,0,2.15-.87l.77-.39,4.08,3.76,2.25-1.77L931.36,108l.55-.65a15.21,15.21,0,0,0,2.86-5.09l.27-.81,5.55-.24.34-2.84-5.34-1.54-.07-.85A15.45,15.45,0,0,0,934,90.31l-.38-.76,3.75-4.08-1.77-2.25-4.86,2.67-.65-.55A15.46,15.46,0,0,0,925,82.49l-.81-.28-.24-5.54-2.84-.34-1.54,5.33-.85.07a15.5,15.5,0,0,0-5.62,1.57l-.77.38-4.08-3.75L906,81.7l2.67,4.85-.55.65a15.88,15.88,0,0,0-1.63,2.35l-2.17-1.22a16.6,16.6,0,0,1,1.35-2.06l-2.88-5.22,5.58-4.39,4.4,4a17.79,17.79,0,0,1,4.88-1.36l1.66-5.74,7,.85.25,6A18,18,0,0,1,931,82.89L936.21,80l4.38,5.58-4,4.4a17.77,17.77,0,0,1,1.35,4.88l5.75,1.65-.85,7.06-6,.25a17.87,17.87,0,0,1-2.48,4.41l2.88,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M925.89,105.57l-1.54-2a7.69,7.69,0,0,0-3.83-13.67,7.59,7.59,0,0,0-5.66,1.59l-1.54-2a10.17,10.17,0,0,1,12.57,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M117.43,48.26a10.84,10.84,0,0,1,10.83,10.83v106.6a10.84,10.84,0,0,1-10.83,10.83H10.83A10.84,10.84,0,0,1,0,165.69V59.09A10.84,10.84,0,0,1,10.83,48.26m0,3.42a7.43,7.43,0,0,0-7.41,7.41v106.6a7.43,7.43,0,0,0,7.41,7.41h106.6a7.43,7.43,0,0,0,7.41-7.41V59.09a7.43,7.43,0,0,0-7.41-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M82,85.22H51.61V71.78H82ZM54.36,82.47H79.21V74.53H54.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "94.88 153 38.7 153 38.7 77.12 52.99 77.12 52.99 79.88 41.45 79.88 41.45 150.25 92.12 150.25 92.12 145.74 94.88 145.74 94.88 153"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "94.88 108.26 92.12 108.26 92.12 79.88 80.59 79.88 80.59 77.12 94.88 77.12 94.88 108.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 60.32,
    y: 77.12,
    width: 12.94,
    height: 2.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "50.36 102.14 46.58 98.15 48.58 96.25 50.36 98.14 56.22 91.97 58.22 93.86 50.36 102.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "50.36 116.22 46.58 112.23 48.58 110.33 50.36 112.22 56.22 106.05 58.22 107.94 50.36 116.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "50.36 130.78 46.58 126.79 48.58 124.9 50.36 126.78 56.22 120.61 58.22 122.51 50.36 130.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "50.36 145.1 46.58 141.12 48.58 139.22 50.36 141.1 56.22 134.93 58.22 136.83 50.36 145.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 62.05,
    y: 95.65,
    width: 24.49,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 62.05,
    y: 109.97,
    width: 15.25,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 62.05,
    y: 124.29,
    width: 10.18,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 62.05,
    y: 138.62,
    width: 10.18,
    height: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M95.6,143.17H91.4a1.36,1.36,0,0,1-1.3-.94l-1.19-3.54-.27-.11-3.34,1.67a1.39,1.39,0,0,1-1.59-.26l-3-3a1.37,1.37,0,0,1-.26-1.59l1.66-3.34-.11-.27-3.54-1.19a1.37,1.37,0,0,1-.94-1.3v-4.2a1.38,1.38,0,0,1,.94-1.3L82,122.64l.11-.27L80.49,119a1.37,1.37,0,0,1,.26-1.59l3-3a1.39,1.39,0,0,1,1.59-.26l3.34,1.66.27-.11,1.19-3.54a1.38,1.38,0,0,1,1.3-.94h4.2a1.38,1.38,0,0,1,1.3.94l1.19,3.54.27.11,3.34-1.66a1.39,1.39,0,0,1,1.59.26l3,3a1.38,1.38,0,0,1,.25,1.59l-1.66,3.34.11.27,3.54,1.19a1.38,1.38,0,0,1,.94,1.3v4.2a1.37,1.37,0,0,1-.94,1.3L105,131.82l-.11.27,1.66,3.34a1.38,1.38,0,0,1-.25,1.59l-3,3a1.38,1.38,0,0,1-1.59.26l-3.34-1.67-.27.11-1.19,3.54A1.38,1.38,0,0,1,95.6,143.17Zm-3.21-2.75h2.22l1.07-3.2a1.34,1.34,0,0,1,.78-.83l1.42-.6a1.41,1.41,0,0,1,1.14,0l3,1.51,1.57-1.56-1.51-3a1.38,1.38,0,0,1,0-1.14l.6-1.43a1.34,1.34,0,0,1,.83-.78l3.2-1.07v-2.22l-3.2-1.07a1.35,1.35,0,0,1-.83-.77l-.6-1.43a1.37,1.37,0,0,1,0-1.14l1.51-3L102,117.12l-3,1.51a1.41,1.41,0,0,1-1.14,0l-1.42-.59a1.35,1.35,0,0,1-.78-.84L94.61,114H92.39l-1.07,3.2a1.36,1.36,0,0,1-.77.84l-1.43.59a1.37,1.37,0,0,1-1.14,0l-3-1.51-1.57,1.57,1.51,3a1.37,1.37,0,0,1,0,1.14l-.59,1.43a1.39,1.39,0,0,1-.84.77l-3.2,1.07v2.22l3.2,1.07a1.38,1.38,0,0,1,.84.78l.59,1.43a1.38,1.38,0,0,1,0,1.14l-1.51,3L85,137.34l3-1.51a1.41,1.41,0,0,1,1.14,0l1.43.6a1.35,1.35,0,0,1,.77.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M93.5,133.52a6.29,6.29,0,1,1,6.29-6.29A6.29,6.29,0,0,1,93.5,133.52Zm0-9.82A3.53,3.53,0,1,0,97,127.23,3.53,3.53,0,0,0,93.5,123.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M28.89,149.8a1.37,1.37,0,0,1-1.23-.76l-3.23-6.45a1.38,1.38,0,0,1-.15-.62v-57a1.38,1.38,0,0,1,1.38-1.38h6.46a1.37,1.37,0,0,1,1.37,1.38v57a1.51,1.51,0,0,1-.14.62L30.12,149A1.37,1.37,0,0,1,28.89,149.8ZM27,141.64l1.85,3.71,1.85-3.71V86.32H27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M20.19,109.64a1.37,1.37,0,0,1-1.37-1.38v-18a1.37,1.37,0,0,1,1.37-1.38h4.42a1.38,1.38,0,0,1,0,2.76h-3v16.61A1.38,1.38,0,0,1,20.19,109.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M28.89,153a1.38,1.38,0,0,1-1.38-1.38v-2.9a1.38,1.38,0,0,1,2.76,0v2.9A1.38,1.38,0,0,1,28.89,153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M28.89,86.32a1.38,1.38,0,0,1-1.38-1.38V79.63a1.38,1.38,0,0,1,2.76,0v5.31A1.38,1.38,0,0,1,28.89,86.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToHostCohort2);
export default __webpack_public_path__ + "static/media/how-to-host-cohort2.c57d01c20ea195e3b20f6260e6d23064.svg";
export { ForwardRef as ReactComponent };